import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import { BreezeWaysService } from '@app/_services/breezeways.service';
import { environment } from '@environments/environment';
import { MessageService } from 'primeng/api';
import { TapeChartService } from '../yield-max/tape-chart';
import { VrboService } from '@app/_services/vrbo.service';

@Component({
    selector: 'app-admin-dashboard',
    templateUrl: './admin-dashboard.component.html',
    styleUrls: ['./admin-dashboard.component.css'],
    providers: [MessageService],
    standalone: false
})
export class AdminDashboardComponent implements OnInit {
    kbmAdminURL: string;
	isSearching = false;

  constructor(
	private breezeWaysService: BreezeWaysService,
	private tapeChartService: TapeChartService,
	private messageService: MessageService,
	public userService: UserService,
  private vrboService: VrboService
) { }

  ngOnInit(): void {
	this.kbmAdminURL = environment.kbmAdminURL;
  }

	saveAllProperties() {
		this.isSearching = true;
			try {
				this.breezeWaysService.saveAllProperties()
					.subscribe(
						res => {
							this.isSearching = false;
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully save all properties', life: 6000 });
						},
						err => {
							this.isSearching = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
			}
	}

  saveAllPropertiesToVrbo() {
    this.isSearching = true;
    try {
      this.vrboService.saveAllProperties()
        .subscribe(
          res => {
            this.isSearching = false;
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully save all properties', life: 6000 });
          },
          err => {
            this.isSearching = false;
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          },
          () => { });
    } catch (error) {
      this.isSearching = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
    }
  }

  syncLOSAllPropertiesToVrbo() {
    this.isSearching = true;
    try {
      this.vrboService.syncLOSAllProperties()
        .subscribe(
          res => {
            this.isSearching = false;
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Sync LOS for All Properties To VRBO.', life: 6000 });
          },
          err => {
            this.isSearching = false;
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          },
          () => { });
    } catch (error) {
      this.isSearching = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: syncLOSAllPropertiesToVrbo' });
    }
  }

  syncUnitAvailabilityAllPropertiesToVrbo() {
    this.isSearching = true;
    try {
      this.vrboService.syncUnitAvailabilityAllProperties()
        .subscribe(
          res => {
            this.isSearching = false;
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully Sync Unit Availability for All Properties To VRBO.', life: 6000 });
          },
          err => {
            this.isSearching = false;
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
          },
          () => { });
    } catch (error) {
      this.isSearching = false;
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: syncLOSAllPropertiesToVrbo' });
    }
  }

	saveAllReservations() {
		this.isSearching = true;
			try {
				this.breezeWaysService.saveAllReservations()
					.subscribe(
						res => {
							this.isSearching = false;
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Successfully save all reservations', life: 6000 });
						},
						err => {
							this.isSearching = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
			}
	}

	syncAllTasksToBreezwayLast45Days() {
		this.isSearching = true;
		this.breezeWaysService.syncExpenseByDays(45).subscribe(
			res => {
				this.isSearching = false;
				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: 'Successfully synced tasks to Breezeway for last 45 days',
					life: 6000
				});
			},
			err => {
				this.isSearching = false;
				console.log('Sync Breezway expense FAIL: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'Failed to sync tasks to Breezeway' });
			}
		);
	}



	saveAllReservationsByProperty(shortTermRentalId:number) {
		this.isSearching = true;
			try {
				this.breezeWaysService.saveAllReservationsByProperty(shortTermRentalId)
					.subscribe(
						res => {
							this.isSearching = false;
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 6000 });
						},
						err => {
							this.isSearching = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
			}
	}

generateRates()
  {
	try
	  {
	  this.tapeChartService.generateRates()
		.subscribe(
		res =>
		{

		},
		err =>
		{
			console.log('generateRates FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
		},
		() => {  });

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rates are being generated, please check back shortly for results.', life: 3000 });

	} catch (error)
	{
		this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while generating rates' });
	}
  }

	getEmailReportOfHomeOwnerArrival() {
		this.isSearching = true;
			try {
				this.userService.getEmailReportOfHomeOwnerArrival()
					.subscribe(
						res => {
							this.isSearching = false;
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Send emails are done to Home Owner Arrival', life: 6000 });
						},
						err => {
							this.isSearching = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
			}
	}

	getEndPointResponse(endPoint: any) {
		this.isSearching = true;
			try {
				this.userService.getEndPointResponse(endPoint)
					.subscribe(
						res => {
							this.isSearching = false;
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Process done successfully ', life: 6000 });
						},
						err => {
							this.isSearching = false;
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
						},
						() => { });
			} catch (error) {
				this.isSearching = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: saveProperties' });
			}
	}

	refreshCacheFromDbAndSyncS3() {
		this.refreshCacheByEndpoint('properties/cache/refresh-db-s3', 'Cache refresh completed.', 'Error while refreshing cache');
	}

	refreshFastSearchCacheFromDbAndSyncS3() {
		this.refreshCacheByEndpoint('properties/cache/refresh-fast-search-db-s3', 'Fast search cache refresh completed.', 'Error while refreshing fast search cache');
	}

	refreshShortTermRentalCacheFromDbAndSyncS3() {
		this.refreshCacheByEndpoint('properties/cache/refresh-short-term-rental-db-s3', 'Short term rental cache refresh completed.', 'Error while refreshing short term rental cache');
	}

	clearInMemoryCache() {
		this.refreshCacheByEndpoint('properties/cache/clear-in-memory', 'In-memory cache clear completed.', 'Error while clearing in-memory cache');
	}

	private refreshCacheByEndpoint(endPoint: string, defaultSuccessMessage: string, defaultErrorMessage: string) {
		this.isSearching = true;
		try {
			this.userService.postEndPointResponse(endPoint)
				.subscribe(
					res => {
						this.isSearching = false;
						const successMessage = res?.message ? res.message : defaultSuccessMessage;
						this.messageService.add({ severity: 'success', summary: 'Success', detail: successMessage, life: 6000 });
					},
					err => {
						this.isSearching = false;
						console.log('Cache refresh FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || defaultErrorMessage });
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Cache refresh exception: ' + JSON.stringify(error));
			this.messageService.add({ severity: 'error', summary: 'Error', detail: defaultErrorMessage });
		}
	}

	triggerEndPoint(endPoint: any, name: any, endPointAletMessage: any) {
		try {
			this.messageService.add({ severity: 'info', summary: 'Alert', detail: endPointAletMessage, sticky: true });
			this.userService.getEndPointResponse(endPoint).subscribe(
				res => {
				},
				err => {
				},
				() => { })
		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: '+name });
		}
	}

}
